import axios from 'axios';
import { appInsights, appInsightsReady } from "../components/AppInsights";
//D365 get the ATS Token API call


const apiCall = async (GUID) => {
  const res = await fetch('/api/d365-lookup', {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ guid: GUID }),
  });
  if (!res.ok) {
    const errBody = await res.json().catch(() => ({}));
    throw new Error(errBody.message || 'Unable to load payment session.');
  }
  return await res.json();
};

export default apiCall;